import { useEffect, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "./App.css";

// Above-the-fold: import normal (critical path)
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';

// Below-the-fold: lazy load (code-split into separate chunks)
const BenefitsSection = lazy(() => import('./components/BenefitsSection'));
const AboutSection = lazy(() => import('./components/AboutSection'));
const CaminhoMethodSection = lazy(() => import('./components/CaminhoMethodSection'));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection'));
const ComparisonSection = lazy(() => import('./components/ComparisonSection'));
const CTABanner = lazy(() => import('./components/CTABanner'));
const FAQSection = lazy(() => import('./components/FAQSection'));
const LeadFormSection = lazy(() => import('./components/LeadFormSection'));
const Footer = lazy(() => import('./components/Footer'));
const WhatsAppFloating = lazy(() => import('./components/WhatsAppFloating'));

// Pages: lazy load (separate routes)
const PrivacyPolicyPage = lazy(() => import('./pages/PrivacyPolicyPage'));
const TermsOfUsePage = lazy(() => import('./pages/TermsOfUsePage'));
const ThankYouPage = lazy(() => import('./pages/ThankYouPage'));

// Minimal placeholder while chunks load
const Placeholder = () => <div style={{ minHeight: '200px' }} />;

function ScrollToTop() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (hash) {
      const id = hash.replace('#', '');
      const el = document.getElementById(id);
      if (el) {
        setTimeout(() => el.scrollIntoView({ behavior: 'smooth' }), 100);
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);
  return null;
}

function HomePage() {
  useEffect(() => {
    document.title = 'Way2Go Growth Marketing | Tráfego Pago com IA e ROAS 4-8x';
    const meta = document.querySelector('meta[name="description"]');
    if (meta) {
      meta.setAttribute('content', 'Transforme tráfego pago em vendas previsíveis. Automação IA 24/7, ROAS 4-8x. Gestão Google Ads e Meta Ads com +5 anos de experiência.');
    }
    const canonical = document.querySelector('link[rel="canonical"]');
    if (canonical) {
      canonical.setAttribute('href', 'https://site-way2go.vercel.app');
    }
  }, []);

  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <StatsSection />
        <Suspense fallback={<Placeholder />}>
          <BenefitsSection />
          <AboutSection />
          <CaminhoMethodSection />
          <TestimonialsSection />
          <ComparisonSection />
          <CTABanner />
          <FAQSection />
          <LeadFormSection />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
        <WhatsAppFloating />
      </Suspense>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/privacidade" element={
          <Suspense fallback={<Placeholder />}>
            <PrivacyPolicyPage />
          </Suspense>
        } />
        <Route path="/termos" element={
          <Suspense fallback={<Placeholder />}>
            <TermsOfUsePage />
          </Suspense>
        } />
        <Route path="/obrigado" element={
          <Suspense fallback={<Placeholder />}>
            <ThankYouPage />
          </Suspense>
        } />
      </Routes>
    </div>
  );
}

export default App;
